// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable prefer-named-capture-group */
import * as R from "ramda"
// @ts-expect-error: Flow to TS migration.
import { stringify } from "query-string"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
type Params = {
  [key: string]: string
}

/**
 * @param query - format: ?key=val&key2=val2 | key=val&key2=val2
 * @returns {Object<string, string>}
 */
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export function parseQuery(query: string = ""): Params {
  return (
    query
      .replace(/(^\?)/, "")
      .split("&")
      .filter(Boolean)
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .reduce<Record<string, any>>((obj, pair) => {
        const [key, val] = pair.split("=").map(decodeURIComponent)
        return Object.assign(obj, {
          [key]: val,
        })
      }, {})
  )
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
type MakeParams = {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}

/**
 * @param params - Object of strings
 * @param pure - if true, skip "?" from returned string
 * @returns string
 */
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export function makeQuery(params: MakeParams, pure: boolean = false): string {
  const qmark = pure ? "" : "?"
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
  return qmark + stringify(params)
}

/**
 * @param query - format: ?key=val&key2=val2 | key=val&key2=val2
 * @param keys - parameters to remove
 * @returns query starting with "?"
 */
export function removeParams(query: string, ...keys: string[]): string {
  return makeQuery(R.omit(keys, parseQuery(query)))
}
